<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="danger">
      <h4 class="alert-heading">
        Part Not Found
      </h4>
      <div class="my-4">
        <p>
          Unfortunately, we could not find the part number you entered
          <b>{{ referenceId }}</b>
        </p>
        <p>If this is a competitor's part number you may search for it in our cross reference.</p>
      </div>
      <div class="call-for-support">
        <p>If you believe you've received this message in error, please call Dealer Support:</p>
        <p class="d-flex align-items-center">
          <font-awesome-icon :icon="phoneIcon" size="2x" class="mr-2" />
          {{ tenantDetails.SupportPhoneNumber }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import { faPhoneSquareAlt } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

  export default {
    name: "PartNotFound",
    components: {
      FontAwesomeIcon,
    },
    props: {
      oemPartCode: {
        type: String,
        default: "",
      },
      partId: {
        type: Number,
        default: 0,
      }
    },
    data: () => ({
      phoneIcon: faPhoneSquareAlt,
    }),
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
      referenceId() {
        if (this.partId && this.partId > 0) {
          return `(Part ID# ${this.partId})`;
        }

        return `(${this.oemPartCode})`;
      },
    },
  };
</script>
